import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import { useForm, SubmitHandler } from "react-hook-form"
import MpgInput from '../../../CommonFormComp/MpgInput';
import MpgSelect from '../../../CommonFormComp/MpgSelect';
import MenuItem from "@mui/material/MenuItem";
import Grid from '@mui/material/Grid';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import CloseIcon from '@mui/icons-material/Close';
import { useGetLanguageListQuery } from '../../../reactQueries/commonRQHooks';
import MpgAutocompleteSingle from "../../../CommonFormComp/MpgAutocompleteSingle";
import { useEffect } from "react";
import { useGetSignedInUserDetails } from "../../../hooksAndFunctions/customHooks/useGetSignedInUserDetails";


/**whereCalled= "create"|"edit" */

const EditBioDialog = ({ open, setOpen, bioDetailTableData, setBioDetailTableData, bioDetailObjToBeEdited, whereCalled, cmsData}) => {

    const { userName } = useGetSignedInUserDetails()

    /**get languagelist */
    const { isSuccess, isFetching, error, data: LangList, isError } = useGetLanguageListQuery();

     // #region Cms content handling
     const fetchBioDetailsComponentLabel = (key) => {
        if (cmsData?.pageContent && cmsData?.pageContent["BioDetailsComponent"]) {
            const adminBioDetailsLabel = cmsData.pageContent["BioDetailsComponent"];
            return returnLabel(adminBioDetailsLabel?.Labels, key)
        }
        return '';
    }

    const fetchCommonCMSLabel = (key) => {
        if (cmsData?.pageContent && cmsData?.pageContent["CommonComponent"]) {
            const commonLabels = cmsData.pageContent["CommonComponent"];
            return returnLabel(commonLabels?.Labels, key)
        }
        return '';
    }

    const returnLabel = (labelArray=[], key) => {
            return labelArray.find((x) => x.Key === key)?.Phrase || '';
    }
    // #endregion

    /**form handling */

    /**this empty default value OBJ requires for form reset */
    const defaultValues = {
        bio_title: '',
        bio_lang: '',
        bio_content: ''
    }
    const bioFormSchema = yup.object().shape({
        bio_title: yup.string().required().max(40),
        bio_lang: yup.object().required("This field is required").typeError("This field is required"),
        bio_content: yup.string().max(1300),
    });

    const bioFormInstance = useForm({
        defaultValues,
        resolver: yupResolver(bioFormSchema)
    });
    const { setValue, getValues } = bioFormInstance

    /** !!!!!!!! autocomplete laguage lists !!!!!!! */
    const masterLangAutocompleteList = !!LangList && LangList.map((item) => {
        return {
            id: item.Id,
            selectOptionLabel: `${item.LanguageCode}-${item.LanguageDescription}`,
            selectOptionValue: item.Id,
            extraData: item
        }
    })

    /**setting existing vlues for edit */
    useEffect(() => {
        if (!!bioDetailObjToBeEdited) {
            const foundItem = !!LangList && LangList.find((item) => item.Id === bioDetailObjToBeEdited?.LanguageId)

            if (!!foundItem) {
                const val = {
                    id: foundItem.Id,
                    selectOptionLabel: `${foundItem.LanguageCode}-${foundItem.LanguageDescription}`,
                    selectOptionValue: foundItem.Id,
                    extraData: foundItem,
                }

                setValue('bio_lang', val || '')
            }
        }
    }, [bioDetailObjToBeEdited, LangList])

    /**we are removing dependency array as we want to set values for every rerender to overcome dialog shortcoming. */
    useEffect(() => {
        setValue('bio_title', bioDetailObjToBeEdited?.TemplateTitle || '')
        setValue('bio_content', bioDetailObjToBeEdited?.Content || '')
    }, [bioDetailObjToBeEdited])

    const onSubmit1 = (data) => {

        const bioDetailTableData_withoutIdTobeEdited = bioDetailTableData.filter((item) => {
            if (item.Id !== bioDetailObjToBeEdited?.Id) {
                return item
            }
        })

        let createdBy = ''
        let updatedBy = ''
        if (whereCalled === "create") {
            createdBy = userName
        } else if (whereCalled === "edit" && bioDetailObjToBeEdited?.flag === "notFromDB") {
            createdBy = userName
        }

        if (whereCalled === "edit" && bioDetailObjToBeEdited?.flag !== "notFromDB") {
            updatedBy = userName
        }

        const bioDetailTableDataWithUpdatedBio = [...bioDetailTableData_withoutIdTobeEdited, {
            ...bioDetailObjToBeEdited,
            TemplateTitle: data.bio_title,
            LanguageId: data?.bio_lang?.extraData?.Id,
            LanguageCode: data?.bio_lang?.extraData?.LanguageCode,
            LanguageDescription: data?.bio_lang?.extraData?.LanguageDescription,
            Content: data.bio_content || '',
            CreatedBy: createdBy,
            UpdatedBy: updatedBy
        }]

        setBioDetailTableData(bioDetailTableDataWithUpdatedBio)

        bioFormInstance.reset(defaultValues)
        setOpen(false);
    }
    /** */
    // console.log("zzz", getValues())
    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick") {
            return '';
        } else {
            setOpen(false);
        }
        /**do not reset form for edit bio dialog */
        // bioFormInstance.reset(defaultValues)
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            disableEscapeKeyDown
        >
            <Box
                sx={{ width: { sm: '500px' } }}
                component="form"
                noValidate
                autoComplete="off"
                onSubmit={bioFormInstance.handleSubmit(onSubmit1)}
            >

                <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
                    {fetchBioDetailsComponentLabel("BioDetails.EditBio")}
                    <IconButton
                        sx={{ ml: 'auto' }}
                        onClick={handleClose}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText></DialogContentText>
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                    >

                        <MpgInput
                            rhfFormInstance={bioFormInstance}
                            label={fetchBioDetailsComponentLabel("BioDetails.BioTemplate")}
                            name={'bio_title'}
                            fullWidth
                            disabled
                        />

                        <MpgAutocompleteSingle
                            rhfFormInstance={bioFormInstance}
                            name={'bio_lang'}
                            label={fetchBioDetailsComponentLabel("BioDetails.BioLanguage")}
                            fullWidth
                            optionList={masterLangAutocompleteList || []}
                            disabled
                        />

                        <MpgInput
                            rhfFormInstance={bioFormInstance}
                            label={fetchBioDetailsComponentLabel("BioDetails.BioContent")}
                            name={'bio_content'}
                            placeholder={fetchBioDetailsComponentLabel("BioDetails.PlaceholderBioContent")}
                            multiline
                            rows={20}
                            fullWidth
                        />
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button type='submit'>{fetchCommonCMSLabel('Common.Update')}</Button>
                    <Button onClick={handleClose}>{fetchCommonCMSLabel('Common.Cancel')}</Button>
                </DialogActions>
            </Box>
        </Dialog>
    )
}
export default EditBioDialog